import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../auth/useAuth'
import { normalizeSupportedLanguage } from '../i18n'

export default function I18nProfileSync() {
  const { profile } = useAuth()
  const { i18n } = useTranslation()
  const location = useLocation()
  const preferredLanguage = normalizeSupportedLanguage(profile?.settings?.user?.language)

  useEffect(() => {
    if (!preferredLanguage) {
      return
    }
    if (new URLSearchParams(location.search).has('lang')) {
      return
    }
    const activeLanguage = normalizeSupportedLanguage(i18n.resolvedLanguage || i18n.language)
    if (activeLanguage === preferredLanguage) {
      return
    }
    void i18n.changeLanguage(preferredLanguage)
  }, [i18n, location.search, preferredLanguage])

  return null
}
